import React from "react";

export const MathfieldInsertBtn = ({
    onClick,
    style,
    ...btnProps
}: { onClick: () => void } & React.HTMLAttributes<HTMLButtonElement>) => {
    return (
        <button
            onClick={onClick}
            style={{
                cursor: "pointer",
                borderRadius: 999,
                backgroundColor: "var(--color-primary)",
                color: "var(--color-primary-dark)",
                padding: "12px 24px",
                fontSize: "14px",
                fontFamily: "var(--knowt-font-name)",
                fontWeight: "bold",
                border: "none",
                ...style,
            }}
            {...btnProps}>
            <style>{`
button {
    outline: none;
}
button:hover {
    outline-offset: "-1px";
    outline: 1px solid var(--color-neutral-black);
}
            `}</style>
            Insert
        </button>
    );
};

export const MathfieldCanceBtn = ({
    onClick,
    style,
    ...btnProps
}: { onClick: () => void } & React.HTMLAttributes<HTMLButtonElement>) => {
    return (
        <button
            className="test"
            onClick={onClick}
            style={{
                cursor: "pointer",
                borderRadius: 999,
                backgroundColor: "transparent",
                color: "var(--color-neutral-black)",
                border: "1px solid var(--color-neutral-1)",
                padding: "12px 24px",
                fontSize: "14px",
                fontWeight: "bold",
                fontFamily: "var(--knowt-font-name)",
                ...style,
            }}
            {...btnProps}>
            <style>{`
button {
    outline: none;
}
button:hover {
    outline-offset: -1px;
    outline: 1px solid var(--color-neutral-black);
}
            `}</style>
            Cancel
        </button>
    );
};

export const MathfieldDialogTitle = ({ children, style, ...props }: React.HTMLAttributes<HTMLSpanElement>) => {
    return (
        <span style={{ fontSize: "20px", lineHeight: "26px", fontWeight: "bold", ...style }} {...props}>
            {children}
        </span>
    );
};
